export enum Store {
    AppliedFilters = 'AppliedFilters',
    SearchResults = 'SearchResults',
    BestSeat = 'BestSeat',
    Recaptcha = 'Recaptcha',
    TicketSelectionDisplayState = 'TicketSelectionDisplayState',
}
